import * as React from "react";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import { styled } from "@mui/material/styles";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "./App.css";
import { TbMovie } from "react-icons/tb";
import LoginUser from "./LoginUser";
import { auth, auth1 } from "./firebase";
import {
  signInWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { useAuthValue } from "./AuthContext";
import Paper from "@mui/material/Paper";
import Modal from "@mui/material/Modal";
import PointImg from "./PointImg";
import ExchangeImg from "./ExchangeImg";
import LoadingImg1 from "./LoadingImg1";
import PointEx from "./PointEx";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60vw",
  boxShadow: 24,
  p: 4,
};

const modalStyle1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
  boxShadow: 24,
  p: 4,
};
const modalStyle2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "40vw",
  boxShadow: 24,
  p: 4,
};

let today = new Date();
let date = new Date();

const monthAgo =
  date.getFullYear() +
  "/" +
  date.getMonth() +
  "/" +
  date.getDate() +
  " " +
  date.getHours() +
  ":" +
  date.getMinutes() +
  ":" +
  date.getSeconds();

const weekAgo1 = date.setDate(date.getDate() - 7);
const weekAgo = new Date(weekAgo1);

const StyledTextField = styled(TextField)(() => ({
  root: {
    width: "100px",
  },
}));

const resGetAction = (actionResData) => {
  const actionObjectAarray = [];
  const { sendit } = actionResData;
  sendit.forEach((action) => {
    const length = sendit.length;
    const id = action.id;
    const userId = action.data.user_id;
    const contentsId = action.data.contents_id;
    const contentsName = action.data.contents_name;
    const contentsDetail = action.data.contents_detail;
    const contentsKeywords = action.data.contents_keywords;
    const timeStamp = action.data.createAt._seconds;
    const point = action.data.point;
    const zoooUserId = action.data.zooo_user_id;
    const d = new Date(timeStamp * 1000);
    const actionDate =
      d.getFullYear() +
      "/" +
      (d.getMonth() + 1) +
      "/" +
      d.getDate() +
      " " +
      ("0" + d.getHours()).slice(-2) +
      ":" +
      ("0" + d.getMinutes()).slice(-2) +
      ":" +
      ("0" + d.getSeconds()).slice(-2);
    actionObjectAarray.push({
      length: length,
      id: id,
      userId: userId,
      contentsId: contentsId,
      contentsDetail: contentsDetail,
      contentsKeywords: contentsKeywords,
      contentsName: contentsName,
      zoooUserId: zoooUserId,
      actionDate: actionDate,
      point: point,
    });
  });
  return actionObjectAarray;
};

function History() {
  const [historyData, setHistoryData] = useState([]);
  const [startTime, setStartTime] = useState(dayjs(weekAgo));
  const [endTime, setEndTime] = useState(dayjs(today));
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [noAuth, setNoAuth] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [point, setPoint] = useState("");
  const [userId, setUserId] = useState("");
  const [findoutUserId, setFindoutUserId] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState("");

  const headers = {
    "Content-Type": "application/json",
    //Authorization: `Bearer ${authToken}`
  };

  const startTS = startTime;
  const sDate = new Date(startTS);
  const startAt =
    sDate.getFullYear() + "/" + (sDate.getMonth() + 1) + "/" + sDate.getDate();
  const endTS = endTime;
  const eDate = new Date(endTS);
  const endAt =
    eDate.getFullYear() + "/" + (eDate.getMonth() + 1) + "/" + eDate.getDate();

  const touchHandler = (event) => {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  };
  document.addEventListener("touchstart", touchHandler, {
    passive: false,
  });

  const searchHistory = () => {
    const getHistory = {
      user_id: userId,
      startAt: startTime,
      endAt: endTime,
    };
    axios
      .post(
        "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/getUserHistory2",
        getHistory,
        { headers: headers }
      )
      .then((response) => {
        const actionDataArray = resGetAction(response.data);
        setHistoryData(actionDataArray);
        //console.log(actionDataArray);
      });
  };

  const handleStartTimeChange = (startTime) => {
    setStartTime(startTime);
  };
  const handleEndTimeChange = (endTime) => {
    setEndTime(endTime);
  };

  const handleLoginModalOpen = () => {
    setLoginModal(true);
  };
  const handleLoginModalClose = () => {
    setIsLoading1(false);
    setLoginModal(false);
  };

  const loginHistory = (e) => {
    setIsLoading1(true);
    e.preventDefault();
    signInWithEmailAndPassword(auth, email, password)
      .then((response) => {
        if (!auth.currentUser.emailVerified) {
          const ActionCodeSettiings = {
            url: `https://point-ex-9709a.web.app/history/mail/${email}`,
          };
          sendEmailVerification(auth.currentUser, ActionCodeSettiings);
          setSuccess("入力したメールアドレスに確認メールを送信しました");
          setEmail("");
          setPassword("");
          setIsLoading(false);
        } else {
        }
      })
      .catch((err) => {
        console.log(err.code);
        switch (err.code) {
          case "auth/wrong-password":
            setError("パスワードが間違っています");
            break;
          case "auth/user-disabled":
            setError("ユーザーが無効です");
            break;
          case "auth/user-not-found":
            setError("ユーザーが存在しません");
            break;
          case "auth/invalid-email":
            setError("メールアドレスの形式が間違っています");
            break;
          case "auth/too-many-requests":
            setError(
              "試行回数制限を超えました。時間をおいて再度ログインをお試しください。"
            );
            break;
          default:
            setError("エラーが発生しました。");
        }
        setIsLoading1(false);
      });
  };
  const move = () => {
    window.location.replace(
      "https://liff.line.me/1645278921-kWRPP32q/?accountId=findout"
    );
  };

  const getHistory = () => {
    const getHistory = {
      user_id: userId,
      startAt: startTime,
      endAt: endTime,
    };
    axios
      .post(
        "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/getUserHistory2",
        getHistory,
        { headers: headers }
      )
      .then((response) => {
        setIsLoading(false);
        handleLoginModalClose();
        const actionDataArray = resGetAction(response.data);
        setHistoryData(actionDataArray);
        setNoAuth(false);
      });
  };

  useEffect(() => {
    auth.onAuthStateChanged(async () => {
      if (auth.currentUser?.emailVerified) {
        const user = {
          email_address: auth.currentUser.email,
        };
        axios
          .post(
            "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/getUser2",
            user,
            { headers: headers }
          )
          .then((res) => {
            if (res.data.items.length !== 0) {
              setUserId(res.data.items[0].id);
              setFindoutUserId(res.data.items[0].data.findout_userId);
              setPoint(res.data.items[0].data.points);
              const getHistory = {
                user_id: res.data.items[0].id,
                startAt: startTime,
                endAt: endTime,
              };
              axios
                .post(
                  "https://us-central1-point-ex-9709a.cloudfunctions.net/pointex/getUserHistory2",
                  getHistory,
                  { headers: headers }
                )
                .then((response) => {
                  setIsLoading(false);
                  handleLoginModalClose();
                  const actionDataArray = resGetAction(response.data);
                  setHistoryData(actionDataArray);
                  //console.log("Auth");
                  setNoAuth(false);
                });
            } else {
              setError("エラーが発生しました（1）");
              setIsLoading(false);
              setIsLoading1(false);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            setNoAuth(true);
          });
      } else {
        setIsLoading(false);
        setNoAuth(true);
        //console.log("NoAuth");
      }
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <Grid container direction="column" alignItems="center">
          <Paper sx={{ ...modalStyle2 }}>
            <LoadingImg1 />
          </Paper>
        </Grid>
      ) : noAuth ? (
        <Grid container direction="column" alignItems="center">
          <Grid marginTop={5} marginBottom={5}>
            <PointImg />
          </Grid>
          <Grid>
            <Typography variant="h6">連携してポイントを確認</Typography>
          </Grid>
          <Grid
            marginTop={2}
            marginBottom={3}
            container
            direction="column"
            alignItems="center"
          >
            <Grid width={"80%"}>
              <LoginUser />
            </Grid>
          </Grid>
          <Grid
            marginTop={3}
            marginBottom={3}
            container
            direction="column"
            alignItems="center"
          >
            <Grid marginBottom={2}>
              <Typography variant="h6">連携済みの方はこちら</Typography>
            </Grid>
            <Grid width={"80%"}>
              <Button
                variant="contained"
                fullWidth
                color="primary"
                onClick={() => {
                  handleLoginModalOpen();
                }}
              >
                ログイン
              </Button>
            </Grid>
            <Modal
              hideBackdrop
              open={loginModal}
              aria-labelledby="title"
              aria-describedby="description"
            >
              <Paper sx={{ ...modalStyle1 }}>
                <Grid container direction="column" alignItems="center">
                  <Modal
                    hideBackdrop
                    open={isLoading1}
                    aria-labelledby="title"
                    aria-describedby="description"
                  >
                    <Paper sx={{ ...modalStyle }}>
                      <LoadingImg1 />
                    </Paper>
                  </Modal>
                  <Typography variant="h5">ログイン</Typography>
                  {success && (
                    <Typography
                      variant="h6"
                      color="success"
                      sx={{ marginTop: 3 }}
                    >
                      {success}
                    </Typography>
                  )}
                  {error && (
                    <Typography
                      variant="h6"
                      color="error"
                      sx={{ marginTop: 3 }}
                    >
                      {error}
                    </Typography>
                  )}
                  <Grid sx={{ width: "70%", marginTop: 5 }}>
                    <TextField
                      margin="normal"
                      type="email"
                      fullWidth
                      value={email}
                      required
                      label="メールアドレス"
                      placeholder="メールアドレスを入力してください。"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid sx={{ width: "70%", marginTop: 5 }}>
                    <TextField
                      margin="normal"
                      type="password"
                      fullWidth
                      value={password}
                      required
                      label="パスワード"
                      placeholder="パスワードを入力してください。"
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid sx={{ width: "70%", marginTop: 5 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      color="primary"
                      onClick={(e) => {
                        loginHistory(e);
                      }}
                    >
                      ログイン
                    </Button>
                  </Grid>
                  <Grid sx={{ width: "70%", marginTop: 5 }}>
                    <Button
                      variant="contained"
                      fullWidth
                      color="error"
                      onClick={() => {
                        handleLoginModalClose();
                      }}
                    >
                      もどる
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Modal>
          </Grid>
        </Grid>
      ) : (
        <Grid className="timeline">
          <Grid container direction="column" alignItems="center">
            <Grid marginTop={3}>
              <Typography variant="h6">ポイント獲得履歴</Typography>
            </Grid>
            <Grid marginTop={2}>
              <Typography variant="body2">所持ポイント</Typography>
            </Grid>
            <Grid marginTop={2} marginBottom={1}>
              <Typography variant="subtitle1">
                <b>{point}ポイント</b>
              </Typography>
            </Grid>
          </Grid>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Grid>
              <Grid
                marginTop={2}
                container
                direction="row"
                justifyContent="center"
              >
                <MobileDatePicker
                  sx={{ width: 150 }}
                  label="開始日"
                  inputFormat="YYYY/MM/DD"
                  value={startTime}
                  onChange={handleStartTimeChange}
                  onAccept={() => {
                    searchHistory();
                  }}
                  componentsProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                    },
                  }}
                />
                <Grid
                  sx={{
                    width: 6,
                    paddingTop: 2,
                  }}
                >
                  -
                </Grid>
                <MobileDatePicker
                  sx={{ width: 150 }}
                  label="終了日"
                  inputFormat="YYYY/MM/DD"
                  value={endTime}
                  onChange={handleEndTimeChange}
                  onAccept={() => {
                    searchHistory();
                  }}
                  componentsProps={{
                    textField: { variant: "outlined", size: "small" },
                  }}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>

          <Grid container direction="column" alignItems="center">
            {isLoading ? (
              <Grid>
                <Typography variant="h6">Now Loading...</Typography>
              </Grid>
            ) : historyData.length === 0 ? (
              <Grid marginTop={5}>
                <Typography variant="h6">履歴がありません</Typography>
              </Grid>
            ) : (
              <Timeline position="alternate" sx={{ width: "90%" }}>
                {historyData.map((item, index) => (
                  <TimelineItem key={item.id}>
                    <TimelineOppositeContent
                      sx={{ m: "auto 0" }}
                      variant="body2"
                      color="text.secondary"
                    >
                      {item.actionDate}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineConnector />
                      <TimelineDot color="success" sx={{ fontSize: "1.5rem" }}>
                        <TbMovie />
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ m: "auto 0", width: "40%" }}>
                      <Grid
                        sx={{ m: "auto 0", width: "100%" }}
                        className="timelinetext"
                      >
                        <Typography variant="body2">動画視聴</Typography>
                        <Typography variant="body2">
                          {item.point}ポイント
                        </Typography>
                        <Typography variant="body2">
                          {item.contentsName}
                        </Typography>
                      </Grid>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>
            )}
          </Grid>
          <Grid
            marginTop={3}
            marginBottom={3}
            container
            direction="column"
            alignItems="center"
          >
            <PointEx
              point={point}
              pointExUserId={userId}
              findoutUserId={findoutUserId}
              getHistory={getHistory}
            />
            <Grid width={"80%"} marginTop={5}>
              <Button
                variant="contained"
                fullWidth
                color="error"
                onClick={() => {
                  move();
                }}
              >
                findoutを開く
              </Button>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
}
export default History;
